import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=4a6871ae&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=js&"
export * from "./submitBtn.vue?vue&type=script&lang=js&"
import style0 from "./submitBtn.vue?vue&type=style&index=0&id=4a6871ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6871ae",
  null
  
)

export default component.exports